export enum SaldoMovimientoTipo {
    CONSEGUIDO,
    CONSUMIDO,
}

export interface SaldoMovimiento {
    idPromo: number;
    nombrePromo: string;
    fecha: Date;
    saldo: number;
    importe: number;
    tipo: SaldoMovimientoTipo;
}

export class SaldoMovimientoHelper {
    static default(): SaldoMovimiento {
        return {
            idPromo: null,
            nombrePromo: null,
            fecha: null,
            saldo: null,
            importe: 0,
            tipo: null,
        };
    }

    static fromAPI(data): SaldoMovimiento {
        const ret = SaldoMovimientoHelper.default();
        ret.idPromo = data.IDPROMO || null;
        ret.nombrePromo = data.NOMBREPROMO || null;
        ret.fecha = data.FECHA ? new Date(data.FECHA) : null;
        ret.saldo = data.SALDO || null;
        ret.importe = data.IMPORTE || 0;
        ret.tipo = data.MOVIMIENTO === 'CONSEGUIDO' ? SaldoMovimientoTipo.CONSEGUIDO : SaldoMovimientoTipo.CONSUMIDO;
        return ret;
    }
}
